import { render } from "./_base-fieldset.vue?vue&type=template&id=3bb50b02"
const script = {}

const cssModules = {}
import style0 from "./_base-fieldset.vue?vue&type=style&index=0&id=3bb50b02&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__